import React, { useState } from "react";
import { Box } from "@mui/material";
import { useSideBarState } from "../../hooks/useSideBarState";
import { NavBar } from "../NavBar/NavBar";
import { SideBar } from "../SideBar/SideBar";
import { navItems } from "./config/navConfig";
import SignatureModal from "../../../../shared/Modal/SignatureModal";
import { ViewSignatureModal } from "../../../../shared/Modal/ViewSignatureModal";
import { useAssinatura } from "../../../../shared/hooks/useAssinatura";

export const LayoutWithNav: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isOpen, toggle } = useSideBarState();
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const { assinatura, salvarAssinatura } = useAssinatura();

  const handleSaveSignature = async (dataUrl: string) => {
    await salvarAssinatura(dataUrl);
    setEditModalOpen(false);
    setViewModalOpen(false);
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <NavBar toggleSideBar={toggle} />
        <SideBar
          items={navItems}
          isOpen={isOpen}
          toggle={toggle}
          onItemClick={(pathOrModal) => {
            if (pathOrModal === "abrirModalAssinatura") {
              setViewModalOpen(true);
            }
          }}
        />

        <Box component="main" sx={{ flexGrow: 1, p: 0, mt: 4 }}>
          {children}
        </Box>
      </Box>

      <ViewSignatureModal
        open={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
        onEdit={() => {
          setViewModalOpen(false);
          setEditModalOpen(true);
        }}
        signatureUrl={
          assinatura
            ? `${process.env.REACT_APP_API_DOMAIN}/storage/${assinatura}`
            : null
        }
      />

      <SignatureModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSaveSignature}
        existingSignature={assinatura?.startsWith("data:") ? assinatura : null}
      />
    </>
  );
};
